// import { createStore } from 'vuex'

// export default createStore({
//   state: {
//   },
//   getters: {
//   },
//   mutations: {
//   },
//   actions: {
//   },
//   modules: {
//   }
// })

import { createStore } from 'vuex'
import auth from './modules/auth'
import project from './modules/project'
import crawling from './modules/crawling'
import user from './modules/user'
import message from './modules/message'
import chat from './modules/chat'
import notify from './modules/notify'
import qaBoard from './modules/qaBoard'
import file from './modules/file'
import insight from './modules/insight'
import notification from './modules/notification'
import dashboard from './modules/dashboard'
import crawlingStats from './modules/crawlingStats'
import report from './modules/report'

export default createStore({
  modules: {
    auth,
    project,
    crawling,
    user,
    message,
    chat,
    notify,
    qaBoard,
    file,
    insight,
    notification,
    dashboard,
    crawlingStats,
    report,
  }
})
